import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

export const Show = ({children}) => {
    const location=useLocation();
    const [showNav,setShowNav]=useState(false);
    useEffect(()=>{
        if(location.pathname === '/'){
            setShowNav(false);
            console.log(location.pathname);

        }
        else{
        setShowNav(true);
        }
    },[location])
  return (
    <div>{showNav && children}</div>
  )
}
